import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../lib/auth";

const TABS = [
  ["leads", "/admin", "Demandes"],
  ["visuals", "/admin/visuals", "Visuels"],
];

export const AdminShell = ({ active, children }) => {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen px-6 md:px-12 py-10" data-testid="admin-page">
      <div className="flex items-center justify-between gap-6">
        <Link to="/" data-testid="admin-home-link"><Logo /></Link>
        <nav className="flex items-center gap-6 font-mono text-[11px] tracking-[0.2em] uppercase" data-testid="admin-tabs">
          {TABS.map(([k, to, l]) => (
            <Link key={k} to={to} data-testid={`admin-tab-${k}`} className={`pb-1 border-b transition-colors duration-300 ${active === k ? "border-[var(--gold)] text-gold" : "border-transparent text-stone hover:text-[var(--bone)]"}`}>{l}</Link>
          ))}
        </nav>
        <button data-testid="admin-logout-btn" onClick={logout} className="flex items-center gap-2 text-sm text-stone hover:text-[var(--bone)] transition-colors duration-300"><LogOut size={16} /> Déconnexion</button>
      </div>
      {children}
    </div>
  );
};
